import ErrorBoundary from "./ErrorBoundary";

export * from "./ErrorBoundary";

export default ErrorBoundary;
